import React, { useEffect } from 'react';

function Toast({ message, type = 'success', onClose }) {
  // 3 s suffisent pour « Enregistré ». Pas pour une explication de deux lignes :
  // un refus du serveur disparaissait avant d'être lu. La durée suit la longueur
  // du texte (environ 60 ms par caractère), plafonnée à 12 s ; l'utilisateur peut
  // de toute façon fermer avec la croix.
  const duree = Math.min(12000, Math.max(3000, String(message || '').length * 60));
  useEffect(() => {
    const timer = setTimeout(onClose, duree);
    return () => clearTimeout(timer);
  }, [onClose, duree]);

  const colors = {
    success: { bg: '#f0fdf4', border: '#bbf7d0', text: '#059669', icon: '✅' },
    error: { bg: '#fff0f0', border: '#fecaca', text: '#ef4444', icon: '❌' },
    info: { bg: '#f0f7ff', border: '#bfdbfe', text: '#3b82f6', icon: 'ℹ️' },
  };

  const c = colors[type];

  return (
    <div style={{
      position: 'fixed', top: '80px', right: '24px', zIndex: 9999,
      background: c.bg, border: `1px solid ${c.border}`, borderRadius: '10px',
      padding: '14px 20px', boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
      display: 'flex', alignItems: 'center', gap: '10px', minWidth: '280px', maxWidth: '460px',
      animation: 'slideIn 0.3s ease',
    }}>
      <style>{`@keyframes slideIn { from { transform: translateX(100px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }`}</style>
      <span style={{ fontSize: '18px' }}>{c.icon}</span>
      <span style={{ fontSize: '14px', fontWeight: '500', color: c.text }}>{message}</span>
      <button onClick={onClose} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: c.text, fontSize: '16px' }}>×</button>
    </div>
  );
}

export default Toast;